import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取钻石信息*/
export function GetDiamonds(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/diamonds/",
        params:data
    })
}

/*获取钻石编辑信息*/
export function DiamondsEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "basicdata/diamondsedit/",
        params:data
    })
}

/*钻石编辑*/
export function DiamondsEdit(data = {}){
    let params = new URLSearchParams();
    params.append('diamondsid',data.diamondsid);
    params.append('size',data.size);
    params.append('carat',data.carat);
    params.append('price',data.price);
return instance.request({
        method: "post",
        url: "basicdata/diamondsedit/",
        data:params
    })
}

/*钻石新增*/
export function DiamondsAdd(data = {}){
    let params = new URLSearchParams();
     params.append('size',data.size);
    params.append('carat',data.carat);
    params.append('price',data.price);
    params.append('name',data.name);
return instance.request({
        method: "post",
        url: "basicdata/diamondsadd/",
        data:params
    })
}

/*钻石删除*/
export function DiamondsDel(data = {}){
    let params = new URLSearchParams();
    params.append('diamondsid',data.diamondsid)
return instance.request({
        method: "post",
        url: "basicdata/diamondsdel/",
        data:params
    })
}